export const MAX_SERVICE_IMAGES = 4;

export const createEmptyImageSlots = () =>
  Array.from({ length: MAX_SERVICE_IMAGES }, () => ({
    existingUrl: null,
    newFile: null,
    newPreviewUrl: null,
  }));

export const createImageSlotsFromExisting = (urls = []) => {
  const slots = createEmptyImageSlots();
  urls.slice(0, MAX_SERVICE_IMAGES).forEach((url, index) => {
    slots[index] = {
      existingUrl: url,
      newFile: null,
      newPreviewUrl: null,
    };
  });
  return slots;
};

export const extractImageUrl = (image) => {
  if (!image) return "";
  if (typeof image === "string") return image.trim();
  if (typeof image === "object") {
    return (
      image.url ||
      image.secure_url ||
      image.imageUrl ||
      image.src ||
      image.path ||
      image.location ||
      ""
    )
      .toString()
      .trim();
  }
  return "";
};
